import React, { useRef } from 'react'

import DeleteCellRenderer from '@/components/Shared/DeleteCellRenderer'
import { defaultSingleSelectionHeaderColumn } from '@/constants/ag-grid-scenario-builder.constant'
import { optimizationDefaultColDefs } from '@/constants/portfolioOptimization.constant'
import { ICriteria } from '@/interfaces/portfolioOptimization.interface'
import {
  removeCriteria,
  removeScreeningCriteriaFromList,
} from '@/states/candidateScreen.slice'
import { portfolioOptimizationDefaultGridOptions } from '@/utils/grid-utils/colDefs'
import { ColDef, GridOptions } from '@ag-grid-community/core'
import { AgGridReact } from '@ag-grid-community/react'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'

type ScreenCriteriaGridProps = {
  criteriaList: ICriteria[]
}

export const ScreenCriteriaGrid: React.FC<ScreenCriteriaGridProps> = ({
  criteriaList,
}: ScreenCriteriaGridProps) => {
  // Grid Configuration
  const dispatch = useDispatch()
  const gridRef = useRef<AgGridReact>(null)

  const onDelete = (data: ICriteria) => {
    dispatch(removeCriteria(data.rowKey as string))
    dispatch(removeScreeningCriteriaFromList(data.rowKey as string))
  }

  const gridOptions = {
    ...portfolioOptimizationDefaultGridOptions,
    sideBar: false,
    noRowsOverlayComponentParams: () => {
      return {
        noRowsMessage: 'No criteria available.',
      }
    },
    rowSelection: 'single' as const,
    columnDefs: [
      {
        ...{
          ...defaultSingleSelectionHeaderColumn,
          suppressHeaderMenuButton: true,
          sortable: false,
          filter: false,
          checkboxSelection: false,
        },
        cellRenderer: (params: any) => (
          <DeleteCellRenderer
            data={params.data}
            onDelete={() => onDelete(params.data)}
          />
        ),
      },
      {
        ...optimizationDefaultColDefs,
        floatingFilter: false,
        headerName: 'Screen Criteria',
        field: 'screenCriteria',
        cellDataType: 'text',
        filter: 'agTextColumnFilter',
        cellRenderer: (params: any) => {
          if (!params.value) return ''
          return params.value.replace(/\b\d+\.?\d*\b/g, (match: string) => {
            const num = parseFloat(match)
            if (isNaN(num)) return match
            return num.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          })
        },
      },
    ] as ColDef[],
  } as GridOptions

  return (
    <>
      <Box
        className='ag-theme-quartz screen-criteria-grid-table'
        boxSizing='border-box'
        // sx={{ ...agGridContainerStyle }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={criteriaList}
          gridOptions={gridOptions}
          data-cy='screen-criteria-grid-ag-grid'
        ></AgGridReact>
      </Box>
    </>
  )
}
